import { tkParse } from '@moke/vue-tk'

export function createLevelTag (string) {
  const levels = string.split('-').filter((element) => element).map(element => Number.parseInt(element))
  levels[levels.length - 1] = levels[levels.length - 1] + 1
  return levels.join('-') + '-'
}

// 获取用户可编辑的第一层的层级信息
export async function getLevel1Info (userhierarchy) {
  if (userhierarchy) {
    return [userhierarchy]
  } else {
    // 超管
    const res = await tkParse.get('/classes/hierarchy', {
      params: {
        where: {
          level: 1
        }
      }
    })
    return res.data.results
  }
}
